import { render, staticRenderFns } from "./MobileDetails.vue?vue&type=template&id=0510f3ad"
import script from "./MobileDetails.vue?vue&type=script&lang=js"
export * from "./MobileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports